import RecoverPasswordForm from './RecoverPasswordForm';

export default RecoverPasswordForm;
